import React, { useState, useEffect } from 'react';
import { ArrowDownOutlined, ArrowUpOutlined, User } from '@ant-design/icons';
import { Card } from 'antd';
import { QuestionCircleOutlined, MailOutlined, PhoneOutlined, PlusCircleFilled } from '@ant-design/icons';
import Meta from 'antd/es/card/Meta';
import { Link } from 'react-router-dom';
import { FaFileContract, FaFileSignature, FaHistory, FaMoneyBill, FaMoneyCheck, FaUserAlt} from 'react-icons/fa';
import { MdEditDocument, MdPayments } from 'react-icons/md';
import { getNotifications } from '../API/getNotification';

const Menu = (props) => {

  const [notifications, setNotifications] = useState({

  })

  useEffect(() => {
    localStorage.setItem('title', 'Bem-vindo a Plataforma');
    localStorage.setItem('type', '1');
  }, [])

  const links = [
    {
      title: 'Receitas Académicas',
      icon: <MdPayments style={{ fontSize: '60px', color: '#047D4B' }} />,
      link: '/propinas',
      group: 'All',
    },
    {
      title: 'Dividas Académicas',
      icon: <MdPayments style={{ fontSize: '60px', color: '#047D4B' }} />,
      link: '/dividas',
      group: 'All',
    },
    {
      title: 'Histórico',
      icon: <FaHistory style={{ fontSize: '60px', color: '#047D4B' }} />,
      link: '/',
      group: 'All'
    },
    {
      title: 'Meu Perfil',
      icon: <FaUserAlt style={{ fontSize: '60px', color: '#047D4B' }} />,
      link: '/meu-perfil',
      group: 'All'
    }
  ]

  const getCurrentNotification = (type) => {
    switch (type) {
      case 'pending-dist':
        return notifications.pending_dist
      case 'approved-dist':
        return notifications.approved_dist
      case 'transfer-dist':
        return notifications.transfer_dist
      case 'approved-plan':
        return notifications.approved_plan
      case 'pre-auth-plan':
        return notifications.pre_auth_plan
      default:
        return 0
    }
  }

  const filteredLinks = links.filter(link => link.group === 'All' || link.group === parseInt(sessionStorage.getItem('access')))


  return (
    <>
      <div className="grid grid-cols-2 sm:grid-cols-4  gap-4 p-2 sm:p-8">
        {filteredLinks.map((link, index) => (
          <Link to={link.link} key={index}>
            <Card
              bordered={false}
              hoverable
              cover={link.icon}
              className="relative"
            >
              <div className="text-sm sm:text-lg text-center">{link.title}</div>
              <p className={`absolute flex justify-center items-center top-0 right-7 w-4 h-4 bg-orange-500 text-white rounded-full ${link.type ? 'visible' : 'hidden'}`}>
                  {getCurrentNotification(link.type)}
                </p>
            </Card>
          </Link>
        ))}
      </div>
    </>
  );
};

export default Menu;